/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import axios from "axios";
import Splide from "@splidejs/splide";
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import slick from 'slick-carousel'



// import Vue dependencies
// import {createApp} from 'vue';
// import homePage from './vue/homepage'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import postTypeArchiveCommunities from "./routes/postTypeArchiveCommunities";
import postTypeArchiveHomes from "./routes/postTypeArchiveHomes";
import postTypeArchivePlans from "./routes/postTypeArchivePlans";
import singleCommunities from "./routes/singleCommunities";
import singlePlans from "./routes/singlePlans";
import singleHomes from "./routes/singleHomes";
import newVsUsed from "./routes/newVsUsed";
import testimonials from "./routes/testimonials";





document.addEventListener( 'DOMContentLoaded', function () {
  var videoTestimonial = new Splide( '#testimonial-video-items', {
    perPage: 1,
    pagination: false,
  } )

  videoTestimonial.mount()
} );





document.addEventListener( 'DOMContentLoaded', function() {
  var mainGallery = new Splide( '.splide', {
      type: 'loop',
      drag   : 'free',
      'pagination' : false,
  } )

  var thumbnails = new Splide( '#thumbnail-carousel', {
    fixedWidth  : 180,
    fixedHeight : 105,
    gap         : 0.1,
    rewind      : true,
    pagination  : false,
    isNavigation: true,
    arrows: false,
    breakpoints : {
      600: {
        fixedWidth : 60,
        fixedHeight: 44,
      },
    },
  } )

  mainGallery.sync( thumbnails );
  mainGallery.mount();
  thumbnails.mount();

} );


Fancybox.bind('[data-fancybox="gallery_lightbox"]', {
  Image: {
    zoom: true,
  },
});

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  postTypeArchiveCommunities,
  singleCommunities,
  postTypeArchivePlans,
  singlePlans,
  singleHomes,
  postTypeArchiveHomes,
  // newVsUsed,
  testimonials
});





// Load Events
jQuery(document).ready(() => routes.loadEvents());

// const homeApp = createApp(homePage);
// homeApp.mount('#home-app');
